import React, { Component } from 'react';

class Loadingpage extends Component {
    render() {
        return (
            <div className="wrap">
                <section className="py-24 px-4 sm:px-6">
                    <div className="max-w-lg mx-auto text-center">
                        <div className="mx-auto w-16 h-16 rounded-full border-4 border-border-subtle border-t-accent animate-spin"></div>
                        <h1 className="mt-8 text-2xl sm:text-3xl font-semibold text-ink-primary">Sending message…</h1>
                    </div>
                </section>
            </div>
        );
    }
}
export default Loadingpage;
